import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LucideAngularModule, LayoutGrid, List, LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'app-view-toggle',
  imports: [LucideAngularModule, TooltipComponent],
  providers: [
    { provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider({ LayoutGrid, List }) },
  ],
  template: `
    <div class="flex items-center gap-1 rounded-lg border border-[#e2e0d9] p-0.5" role="group" aria-label="View mode">
      <app-tooltip text="Grid view">
        <button
          type="button"
          class="p-1.5 rounded-md transition-colors"
          [class.bg-[#e8e5df]]="viewMode() === 'grid'"
          [class.text-[#26332b]]="viewMode() === 'grid'"
          [class.text-[#73716d]]="viewMode() !== 'grid'"
          (click)="viewModeChange.emit('grid')"
          aria-label="Switch to grid view"
          [attr.aria-pressed]="viewMode() === 'grid'"
        >
          <lucide-angular name="layout-grid" [size]="16" />
        </button>
      </app-tooltip>
      <app-tooltip text="List view">
        <button
          type="button"
          class="p-1.5 rounded-md transition-colors"
          [class.bg-[#e8e5df]]="viewMode() === 'list'"
          [class.text-[#26332b]]="viewMode() === 'list'"
          [class.text-[#73716d]]="viewMode() !== 'list'"
          (click)="viewModeChange.emit('list')"
          aria-label="Switch to list view"
          [attr.aria-pressed]="viewMode() === 'list'"
        >
          <lucide-angular name="list" [size]="16" />
        </button>
      </app-tooltip>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewToggleComponent {
  viewMode = input.required<'grid' | 'list'>();
  viewModeChange = output<'grid' | 'list'>();
}
